<div class="g-layout__container">
    <!-- Page Header -->
    <div class="reports-header">
        <div class="reports-title">
            <i class="fa-solid fa-file-chart-line"></i>
            <span>{{ 'MyReports' | navTitle | async }}</span>
        </div>
    </div>
    <div class="br"></div>
    
    <!-- Strategy Selector -->
    <div class="strategy-selector">
        <label class="selector-label">
            <i class="fa-solid fa-bullseye"></i>
            {{'select_the_strategy' | translate}}
        </label>
        <p-dropdown [(ngModel)]="selectedStrategyId"
                    [options]="strategyOptions" 
                    optionLabel="name" 
                    optionValue="strategyId"
                    (onChange)="strategyOptionsChange()"
                    placeholder="{{'select_the_strategy' | translate}}">
        </p-dropdown>
    </div>

    <!-- Reports Cards -->
    <div class="reports-cards">
        <!-- My Projects Report Card -->
        <div class="report-card">
            <div class="card-header">
                <i class="fa-solid fa-project-diagram"></i>
                <h3>{{'my_projects_report' | translate}}</h3>
            </div>
            <div class="card-body">
                <div class="card-filters">
                    <div class="filter-item">
                        <label>{{'year' | translate}}</label>
                        <p-dropdown [(ngModel)]="projectStatusYear"
                                    [options]="yearsOptions" 
                                    optionLabel="name"
                                    appendTo="body"
                                    placeholder="{{'select_year' | translate}}">
                        </p-dropdown>
                    </div>
                </div>
                <div class="card-actions">
                    <button pButton class="action-btn view-btn" (click)="showMyProjectsReport()">
                        <i class="fa-solid fa-eye"></i>
                        {{'view_report' | translate}}
                    </button>
                    <button pButton class="action-btn print-btn" (click)="printReport('my-projects')" [disabled]="selectedType !== 'my-projects'">
                        <i class="fa-solid fa-print"></i>
                        {{'print' | translate}}
                    </button>
                    <button pButton class="action-btn download-btn" (click)="downloadMyProjectsReport('excel')" [disabled]="isDownloading">
                        <i class="fa-solid fa-download"></i>
                        {{'download_excel' | translate}}
                    </button>
                </div>
            </div>
        </div>

        <!-- My Indicators Report Card -->
        <div class="report-card">
            <div class="card-header">
                <i class="fa-solid fa-chart-line"></i>
                <h3>{{'my_indicators_report' | translate}}</h3>
            </div>
            <div class="card-body">
                <div class="card-filters">
                    <div class="filter-item">
                        <label>{{'year' | translate}}</label>
                        <p-dropdown [(ngModel)]="year"
                                    [options]="yearsOptions" 
                                    optionLabel="name"
                                    optionValue="id"
                                    appendTo="body"
                                    placeholder="{{'select_year' | translate}}">
                        </p-dropdown>
                    </div>
                </div>
                <div class="card-actions">
                    <button pButton class="action-btn view-btn" (click)="showMyIndicatorsReport()">
                        <i class="fa-solid fa-eye"></i>
                        {{'view_report' | translate}}
                    </button>
                    <button pButton class="action-btn print-btn" (click)="printReport('my-indicators')" [disabled]="selectedType !== 'my-indicators'">
                        <i class="fa-solid fa-print"></i>
                        {{'print' | translate}}
                    </button>
                    <button pButton class="action-btn download-btn" (click)="downloadMyIndicatorsReport('excel')" [disabled]="isDownloading">
                        <i class="fa-solid fa-download"></i>
                        {{'download_excel' | translate}}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Report Results Section -->
    @if(selectedType === "my-projects") {
    <div class="report-results">
        <div class="result-header">
            <i class="fa-solid fa-chart-line"></i>
            <h3>{{"my_projects_status_report"|translate}} - {{projectStatusYear.name}}</h3>
        </div>

        <p-table [class]="dir" 
                 [value]="myProjects"
                 styleClass="results-table">
            
            <ng-template pTemplate="header">
                <tr>
                    <th></th>
                    <th>{{'report_initiative_name' | translate}}</th>
                    <th>{{'report_strategic_linkage' | translate}}</th>
                    <th>{{'indicator' | translate}}</th>
                    <th>{{'report_initiative_status' | translate}}</th>
                    <th>{{'report_execution_date' | translate}}</th>
                    <th>{{'report_progress_percentage' | translate}}</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-project let-rowIndex="rowIndex">
                <tr>
                    <td class="font-bold">{{rowIndex+1}}</td>
                    <td>{{project.name}}</td>
                    <td>
                        @for (projectMapping of project.projectMappings; track projectMapping) {
                        {{projectMapping.goal_code}}
                        }
                    </td>
                    <td>
                        <ul class="indicator-list">
                            @for (projectMapping of project.projectMappings; track projectMapping) {
                            <li>{{projectMapping.indicator_name}}</li>
                            }
                        </ul>
                    </td>
                    <td class="text-center">
                        <p-tag [severity]="getSeverity(project.status_name)" [value]="project.status_name" />
                    </td>
                    <td>
                        <div class="date-range">
                            <div class="date-item">
                                <i class="fa-solid fa-calendar-day"></i>
                                <span>{{project.start_date|date}}</span>
                            </div>
                            <div class="date-item">
                                <i class="fa-solid fa-calendar-check"></i>
                                <span>{{project.end_date|date}}</span>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="progress-cell">
                            <span class="progress-value">{{project.progress_percentage}}%</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    }

    @if(selectedType === "my-indicators") {
    <div class="report-results">
        <div class="result-header">
            <i class="fa-solid fa-chart-column"></i>
            <h3>{{"my_indicators_results_report"|translate}} - {{year}}</h3>
        </div>

        <p-table [class]="dir" 
                 [value]="myIndicators"
                 styleClass="results-table">
            
            <ng-template pTemplate="header">
                <tr>
                    <th></th>
                    <th>{{'indicator_code' | translate}}</th>
                    <th>{{'indicator' | translate}}</th>
                    <th>{{'target_value' | translate}}</th>
                    <th>{{'actual_value' | translate}}</th>
                    <th>{{'achievement_rate' | translate}}</th>
                    <th>{{'performance_status' | translate}}</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-indicator let-rowIndex="rowIndex">
                <tr>
                    <td class="font-bold">{{rowIndex+1}}</td>
                    <td>{{indicator.code}}</td>
                    <td>{{indicator.name}}</td>
                    <td>{{indicator.target_value}}</td>
                    <td>{{indicator.actual_value}}</td>
                    <td>{{indicator.achievement_rate}}%</td>
                    <td class="text-center">
                        <p-tag [severity]="getSeverity(indicator.performance_status)" [value]="indicator.performance_status" />
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    }

</div>

